<div *ngIf="googlePlaceAdditionalData?.opening_hours" class="opening-hours">
    <div class="flex items-center">
        <strong>Hours</strong>
        <span dot
              [ngStyle]="{'color':googlePlaceAdditionalData.opening_hours.open_now?'#82e064':'#f9795c'}">·</span>
        <span *ngIf="googlePlaceAdditionalData.opening_hours.open_now">OPEN NOW</span>
        <span *ngIf="!googlePlaceAdditionalData.opening_hours.open_now">CLOSED NOW</span>
    </div>

    <div *ngFor="let t of googlePlaceAdditionalData.opening_hours.weekday_text">
        {{ t }}
    </div>
</div>

<!--<ng-container *ngIf="hours" class="opening-hours">-->
<!--    <strong>Opening Hours</strong>-->
<!--    <div *ngFor="let t of hoursText">-->
<!--        {{t}}-->
<!--    </div>-->
<!--</ng-container>-->


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/visitor/place.opening.hours/place.opening.hours.component.html